import {
  logisticsKeys,
  useLogisticsRevision as useSharedLogisticsRevision,
  type IUseLogisticsRevisionArgs,
  type IUseLogisticsRevisionResult,
} from '@d-orca/shared/client/hooks';
import { fetchDeliveryStatuses, fetchSiteLogistics, fetchSuppliers } from '@apis/logistics';
import { fetchSiteMap } from '@apis/siteMap';
import { fetchLogisticsRevision } from '@apis/logisticsRevision';

type IBoundLogisticsRevisionArgs = Omit<IUseLogisticsRevisionArgs, 'fetchers' | 'extraReads'>;

/**
 * The Logistics page's refresh-to-edit state (spec
 * 2026-09-29-logistics-refresh-to-edit): the shared hook, bound to the web's
 * reads. The site map and the supplier list are reloaded with the page's own
 * two reads — a reload moves the cache only when ALL four landed.
 */
export function useLogisticsRevision(args: IBoundLogisticsRevisionArgs): IUseLogisticsRevisionResult {
  return useSharedLogisticsRevision({
    ...args,
    fetchers: { revision: fetchLogisticsRevision, logistics: fetchSiteLogistics, statuses: fetchDeliveryStatuses },
    extraReads: [
      { queryKey: ['site-map', args.siteId], fetch: fetchSiteMap },
      { queryKey: logisticsKeys.suppliers(args.siteId), fetch: fetchSuppliers },
    ],
  });
}
